module.exports = __webpack_public_path__ + "assets/images/environment-editor-efe992a4a7fc17ceec6af45461f4edf8.jpg";